import { Routes } from '@angular/router';
import { AccessDeniedComponent } from './core/components/access-denied/access-denied.component';
import { LoginComponent } from './core/components/login/login.component';
import { NotFoundComponent } from './core/components/not-found/not-found.component';
import { MainShellComponent } from './core/components/main-shell/main-shell.component';
import { ForgottenPasswordComponent } from './core/components/forgotten-password/forgotten-password.component';
import { PasswordComponent } from './core/components/password/password.component';

export const routes: Routes = [
  {
    path: 'password/:token',
    loadComponent: () =>
      import('./core/components/password/password.component').then(
        (m) => m.PasswordComponent
      ),
  },
  {
    path: 'password-reset/:token',
    loadComponent: () =>
      import('./core/components/password/password.component').then(
        (m) => m.PasswordComponent
      ),
    data: { isReset: true },
  },
  {
    path: 'password-change/:token',
    loadComponent: () =>
      import('./core/components/password/password.component').then(
        (m) => m.PasswordComponent
      ),
    data: { isChange: true },
  },
  {
    path: 'login',
    loadComponent: () =>
      import('./core/components/login/login.component').then(
        (m) => m.LoginComponent
      ),
  },
  {
    path: 'forgotten-password',
    loadComponent: () =>
      import(
        './core/components/forgotten-password/forgotten-password.component'
      ).then((m) => m.ForgottenPasswordComponent),
  },
  {
    path: 'access-denied',
    loadComponent: () =>
      import('./core/components/access-denied/access-denied.component').then(
        (m) => m.AccessDeniedComponent
      ),
  },
  {
    path: '',
    loadComponent: () =>
      import('./core/components/main-shell/main-shell.component').then(
        (m) => m.MainShellComponent
      ),
    children: [
      {
        path: '',
        redirectTo: 'customer',
        pathMatch: 'full',
      },
      {
        path: 'home',
        loadComponent: () =>
          import('./feature/home/home.component').then((m) => m.HomeComponent),
      },
      {
        path: 'customer',
        loadChildren: () =>
          import('./feature/customer/customer.routes').then(
            (m) => m.CUSTOMER_ROUTES
          ),
      },
    ],
  },
  {
    path: '**',
    loadComponent: () =>
      import('./core/components/not-found/not-found.component').then(
        (m) => m.NotFoundComponent
      ),
  },
];
